import { format, isSameMonth, startOfQuarter } from 'date-fns';
import colors from 'seagull/foundations/colors.module.scss';
import { RevenueStatus } from '~/models/HistoricRevenueModel';
import { utils } from '~/utils';
const paidColor = colors.purple700;
const expectedColor = colors.dark200;
const paidExternallyColor = colors.purple300;
export const revenueWidgetTextsPath = 'home.dashboard.revenueWidget';
export const revenueStatusOrder = [
    RevenueStatus.Paid,
    RevenueStatus.PaidExternally,
    RevenueStatus.Expected
];
export const colorsMap = {
    [RevenueStatus.Paid]: paidColor,
    [RevenueStatus.Expected]: expectedColor,
    [RevenueStatus.PaidExternally]: paidExternallyColor
};
export const getLabelMap = (legendTexts)=>({
        [RevenueStatus.Paid]: legendTexts.paidViaAnchor(),
        [RevenueStatus.Expected]: legendTexts.expected(),
        [RevenueStatus.PaidExternally]: legendTexts.paidExternally()
    });
export const getLegendItems = (data, legendTexts)=>revenueStatusOrder.filter((status)=>data.some((item)=>item[status].totalAmount.gt(0))).map((status)=>({
            status,
            label: getLabelMap(legendTexts)[status],
            color: colorsMap[status]
        }));
export const getXAxisText = (props)=>{
    const date = props.payload.value;
    return isSameMonth(startOfQuarter(date), date) ? format(date, 'MMM') : '';
};
export const getTooltipItems = (payload, labelMap)=>{
    if (!payload || !payload.length) return;
    const historicRevenueModel = payload[0].payload;
    return revenueStatusOrder.filter((status)=>historicRevenueModel[status].totalAmount.gt(0)).map((status)=>({
            label: "".concat(utils.formatDollarAmount(historicRevenueModel[status].totalAmount), " ").concat(labelMap[status]),
            color: colorsMap[status]
        }));
};
export const getTooltipTitle = (_label, payload)=>{
    if (!payload || !payload.length) return '';
    return format(payload[0].payload.date, 'MMMM');
};
